export class RefineBiographyDto {
  readonly profileId!: string;
  readonly biography!: string;
  readonly grammarOnly!: boolean;

  constructor(args: RefineBiographyDto) {
    Object.assign(this, args);
  }
}
